// @generated by protoc-gen-connect-es v1.3.0 with parameter "target=ts,import_extension=.js"
// @generated from file rolodex.proto (package rolodex, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { DismissMatchRequest, DismissMatchResponse, GetMatchesRequest, GetMatchesResponse, GetSyncStatusRequest, GetSyncStatusResponse, ImportContactsRequest, ImportContactsResponse, PingRequest, PingResponse, RemoveDataRequest, RemoveDataResponse, StartPhoneVerificationRequest, StartPhoneVerificationResponse, VerifyPhoneRequest, VerifyPhoneResponse } from "./rolodex_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service rolodex.RolodexService
 */
export const RolodexService = {
  typeName: "rolodex.RolodexService",
  methods: {
    /**
     * @generated from rpc rolodex.RolodexService.Ping
     */
    ping: {
      name: "Ping",
      I: PingRequest,
      O: PingResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc rolodex.RolodexService.GetSyncStatus
     */
    getSyncStatus: {
      name: "GetSyncStatus",
      I: GetSyncStatusRequest,
      O: GetSyncStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc rolodex.RolodexService.StartPhoneVerification
     */
    startPhoneVerification: {
      name: "StartPhoneVerification",
      I: StartPhoneVerificationRequest,
      O: StartPhoneVerificationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc rolodex.RolodexService.VerifyPhone
     */
    verifyPhone: {
      name: "VerifyPhone",
      I: VerifyPhoneRequest,
      O: VerifyPhoneResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc rolodex.RolodexService.ImportContacts
     */
    importContacts: {
      name: "ImportContacts",
      I: ImportContactsRequest,
      O: ImportContactsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc rolodex.RolodexService.GetMatches
     */
    getMatches: {
      name: "GetMatches",
      I: GetMatchesRequest,
      O: GetMatchesResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc rolodex.RolodexService.DismissMatch
     */
    dismissMatch: {
      name: "DismissMatch",
      I: DismissMatchRequest,
      O: DismissMatchResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc rolodex.RolodexService.RemoveData
     */
    removeData: {
      name: "RemoveData",
      I: RemoveDataRequest,
      O: RemoveDataResponse,
      kind: MethodKind.Unary,
    },
  }
} as const;

